import { Description, Heading, TitleContainer } from "./Title.styled";
import { Star } from "./Star";
import { PricingActualPlans } from "../../../interfaces";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { useTranslation } from "react-i18next";

interface TitleProps {}

export const Title = observer(({}: TitleProps) => {
	const { pricingActualStore } = useStores();

	const { t } = useTranslation();

	return (
		<TitleContainer>
			<Star padding0 />
			<Heading>
				{t("pages.pricing.title", {
					percent: [PricingActualPlans.PACKS, PricingActualPlans.SKILL_BUNDLES].includes(pricingActualStore.plans)
						? 50
						: 25,
				})}
				<Description>{t("pages.pricing.description")}</Description>
			</Heading>
		</TitleContainer>
	);
});
